import { render, staticRenderFns } from "./Order.vue?vue&type=template&id=6ef8ae9a&lang=pug"
import script from "./Order.vue?vue&type=script&lang=coffee"
export * from "./Order.vue?vue&type=script&lang=coffee"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports